// Copyright (c) 2016 Deere & Company

import UseAmount, {getDefaultState as getUseAmountDefaultState} from './use-amount';
import File from './file';
import TcsmAmountOfUse, {getDefaultState as getTcsmAmountOfUseDefaultState} from './tcsm-amount-of-use';
import t from 'tcomb';

const MeasurementReading = t.struct({
    commentsToDealer: t.maybe(t.String),
    date: t.Number,
    dealerComments: t.maybe(t.String),
    description: t.String,
    documentNumber: t.String,
    file:  t.maybe(t.list(File, 'Files')),
	id: t.maybe(t.String),
    internalDeereComments: t.maybe(t.String),
    isEditAllowed: t.maybe(t.Bool),
    isTcsm: t.maybe(t.Bool),
    latestPerUnit: t.maybe(t.Bool),
	pin: t.maybe(t.String),
    status: t.maybe(t.String),
	tcsmData: t.maybe(TcsmAmountOfUse),
    useAmount: UseAmount
}, {
    name: 'MeasurementReading',
    strict: true
});

export const getDefaultState = () => new MeasurementReading({
    commentsToDealer: '',
    date: 0,
    dealerComments: '',
    description: '',
    documentNumber: '',
    file:  [],
	id: '',
    internalDeereComments: '',
    isEditAllowed: true,
    isTcsm: false,
    latestPerUnit: false,
	pin: '',
    status: '',
	tcsmData: getTcsmAmountOfUseDefaultState(),
    useAmount: getUseAmountDefaultState()
});

export default MeasurementReading;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/measurement-reading.js